import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthenticationV2Service } from '@brand-lolly/app/authentication-v2/services/authentication-v2.service';

/**
 * Plain sign-in gate: lets a route through only for an authenticated user,
 * anonymous visitors go to the login page. No onboarding / subscription
 * logic — used by pages like `/subscribe` (admin-shared checkout links)
 * where the visitor signs in and simply follows the link again.
 */
export const signedInGuard: CanActivateFn = (): boolean | UrlTree => {
	const authenticationService = inject(AuthenticationV2Service);
	const router = inject(Router);
	return authenticationService.isUserSignedIn()
		? true
		: router.createUrlTree(['/authentication']);
};
